@charset "UTF-8";

/* src/app/forms/importacao-dados/d-para-component/dparamodal/dparamodal.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  padding: 0;
}
h1 {
  color: #3f51b5;
  font-size: 1.5em;
  margin-bottom: 15px;
  text-align: center;
}
h2 {
  margin: 0 0 15px 0;
  padding: 20px 20px 0 20px;
  flex-shrink: 0;
  flex: 0 0 auto;
}
table {
  width: 100%;
}
.cell-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.table-container {
  flex: 1;
  overflow: auto;
  width: 100%;
  position: relative;
  padding: 10px;
}
.mat-mdc-dialog-actions {
  justify-content: flex-end;
  overflow: hidden;
  width: 100%;
  margin-bottom: 0px;
  border-top: 1px solid #e0e0e0;
}
button {
  margin: 0 10px;
  padding: 6px 12px;
  font-size: 14px;
}
button[color=warn] {
  background-color: #f44336;
  color: white;
}
button[color=primary] {
  background-color: #3f51b5;
  color: white;
}
.custom-dialog-container {
  margin: 0px !important;
  padding: 0px !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.form-field-density-4 {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;
}
.margin-left-btn {
  margin-left: 48px;
}
.header-config {
  margin-bottom: 10px;
  display: flex;
  position: relative;
  flex-direction: row;
  padding: 0 20px 10px 20px;
  border-bottom: 1px solid #e0e0e0;
  gap: 10px;
}
.marginLeftIcon {
  margin-left: -40px;
}
.margin-top16 {
  margin-top: 14px;
}
.marginLeft {
  margin-left: 10px;
}
.example-full-width {
  width: 100%;
}
.endpoint {
  width: 50%;
}
.token {
  margin-left: 27px;
}
.tokenForm {
  margin-top: 5px;
}
.load-json-button {
  line-height: 25px;
  margin-left: -1px;
}
.textJson {
  border: 1px solid;
}
.loadJsonPersonalized {
  margin-top: 10px;
  line-height: 25px;
  margin-left: -1px;
}
.header-config-left {
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 10px;
}
.header-config-right {
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 10px;
}
/*# sourceMappingURL=dparamodal.component.css.map */
